import { HealthPlanRelevanceSplit } from '@estercare/ester-shared'
import { theme } from '../../theme/theme'
import { ChartStep } from '../../components/charts/type'

export const RELEVANCE_KEYS = {
  completely: 'completely',
  partially: 'partially',
  notAtAll: 'notAtAll',
} as const

type RelevanceKey = (typeof RELEVANCE_KEYS)[keyof typeof RELEVANCE_KEYS]

export const getRelevanceSteps = (t: (key: string) => string): ChartStep[] => [
  { key: RELEVANCE_KEYS.completely, name: t('admin.statistics.relevanceCompletely'), color: theme.color.plum },
  { key: RELEVANCE_KEYS.partially, name: t('admin.statistics.relevancePartially'), color: theme.color.plumSoft },
  { key: RELEVANCE_KEYS.notAtAll, name: t('admin.statistics.relevanceNotAtAll'), color: theme.color.beigeDark },
]

export const getRelevanceValues = ({
  completelyPct,
  partiallyPct,
  notAtAllPct,
}: HealthPlanRelevanceSplit): Record<RelevanceKey, number> => ({
  [RELEVANCE_KEYS.completely]: Math.round(completelyPct),
  [RELEVANCE_KEYS.partially]: Math.round(partiallyPct),
  [RELEVANCE_KEYS.notAtAll]: Math.round(notAtAllPct),
})
